import React from 'react'
import PropTypes from 'prop-types'

import CheckoutSectionHeader from './CheckoutSectionHeader'
import CheckoutSectionBody from './CheckoutSectionBody'

const CheckoutSection = ({ label, children, classname, hidden = false, hideBodyBorder = false }) => (
  <div
    className={classname || label.toLowerCase().replace(' ', '-') + (hidden ? " hidden" : "")}
        style={{ marginBottom: '2rem' }}
  >
    <CheckoutSectionHeader label={label} />
    <CheckoutSectionBody hideBodyBorder={hideBodyBorder}>
      {children}
    </CheckoutSectionBody>
  </div>
)

CheckoutSection.propTypes = {
  label: PropTypes.string.isRequired,
  classname: PropTypes.string,
  hidden: PropTypes.bool,
  hideBodyBorder: PropTypes.bool
}

export default CheckoutSection


// WEBPACK FOOTER //
// ./src/Components/checkout/components/CheckoutSection.jsx